import { decode } from '@msgpack/msgpack'
import { PlanetType } from '../types';

const STATIC_DATASET_URL = './data/exoplanets_data_composite.msgpack'

export async function loadExoplanetsData() {
    const response = await fetch(STATIC_DATASET_URL);
    const arrayBuffer = await response.arrayBuffer();
    const data = decode(new Uint8Array(arrayBuffer)) as Record<string, any>;

    data['Sol'] = generateSolData()

    return data
}

function generateSolData() {
    return {
        'b': { planet_type: 'Terrestrial', pl_orbsmax: 1 },
        'c': { planet_type: 'Terrestrial', pl_orbsmax: 2 },
        'd': { planet_type: 'Terrestrial', pl_orbsmax: 3 },
        'e': { planet_type: 'Terrestrial', pl_orbsmax: 4 },
        'f': { planet_type: 'Gas Giant', pl_orbsmax: 5 },
        'g': { planet_type: 'Gas Giant', pl_orbsmax: 6 },
        'h': { planet_type: 'Neptune-like', pl_orbsmax: 7 },
        'i': { planet_type: 'Neptune-like', pl_orbsmax: 8 },
    }
}

const planetTypeMapping = {
    "Gas Giant": PlanetType.Jovian,
    "Neptune-like": PlanetType.Neptunian,
    "Super Earth": PlanetType.SuperEarth,
    "Terrestrial": PlanetType.Terrestrial,
    "Unknown": PlanetType.Unknown
}
export function mapDatasetPlanetTypeToEnum(planetTypeStr: string) {
    return planetTypeMapping[planetTypeStr]
}